import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #BF8A0066',
    boxSizing: 'border-box',
    width: '100%',
    height: '52px',
    padding: '0 24px',
    backgroundColor: '#FFF0C9',
    color: '#BF8A00'
  },

  text: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.size.base,

    '& .icon': {
      marginRight: '10px'
    }
  },

  link: {
    marginLeft: '5px',
    cursor: 'pointer',
    textDecoration: 'underline',
    userSelect: 'none'
  },

  close: {
    cursor: 'pointer'
  }
}))

export default useStyles
